'use strict';
angular.module('MW.Framework.CoreUserService', [
    'MW.Framework.TranslationService',
    'MW.Framework.CoreCommon',
    'Configuration',
    'MW.Framework.TranslationService',
    'ngCookies',
    'MW.Framework.DialogService',
    'MW.Framework.ErrorMessageService',
    'MW.Framework.MomentService',
    'MW.Framework.TimezoneService',
    'MW.Framework.CoreErrorNotificationService',
    'MW.Framework.EntitlementService',
    'MW.Framework.PageStateService'
])
.service('CoreUserService', [
    '$http',
    '$injector',
    'CoreCommon',
    'DASHBOARD_SERVICES_URL',
    '$window',
    '$rootScope',
    'translationService',
    '$cookies',
    'LOGOUT_URL',
    '$q',
    'DialogService',
    'TimezoneService',
    'ErrorMessageService',
    'moment',
    'CoreErrorNotificationService',
    'EntitlementService',
    '$location',
    'PageStateService',
    '$translate',
    function($http,
             $injector,
             CoreCommon,
             DASHBOARD_SERVICES_URL,
             $window,
             $rootScope,
             translationService,
             $cookies,
             LOGOUT_URL,
             $q,
             DialogService,
             TimezoneService,
             ErrorMessageService,
             moment,
             CoreErrorNotificationService,
             EntitlementService,
             $location,
             PageStateService,
             $translate) {
    var current,
        formatName,
        CoreUserService,
        usersEntitlement = 'users',
        timezoneFlashId = null,
        currentUserDeferred = $q.defer();

    formatName = function formatName (user) {
        return CoreCommon.isUsable(user) ? user.firstName + ' ' + user.lastName : '';
    };

    CoreUserService = {
        setCurrent: function setCurrent(user, doCheckUserTimezone) {
            current = user;

            // Set our language manually, so that we get the other side effects of changing language (event broadcast, mainly)
            this.setLanguage(this.getLanguage());

            // Let the rest of the app know that the user has been updated.
            $rootScope.$broadcast('userChanged', current);

            // And anyone just waiting for us.
            currentUserDeferred.resolve(user);

            // Updated the deferred obj for any subsequent callers
            currentUserDeferred.promise.$$state.value = user;

           // if the doCheckUserTimezone is set to true then call the method to update the timezone coz setCurrent method calls thrice when we update the personal settings.
           if(doCheckUserTimezone === true && typeof doCheckUserTimezone !== 'undefined'){
               checkUserTimezone();
           }
        },
        /**
         * Returns the current user object (which may not be set yet!) or a promise that will resolve to the
         * current user once auth is complete.  The latter is preferred.
         *
         * @param boolean waitForAuth If true we'll return a promise that will resolve once auth is complete
         * @returns {*}
         */
        getCurrent: function getCurrent(waitForAuth){
            if (waitForAuth) {
                return currentUserDeferred.promise;
            } else {
                return current;
            }
        },
        updateTimeZoneByBrowserTime: function updateTimeZoneByBrowserTime(event){
            var userId = CoreUserService.getId(),
                personalSettings = {},
                settingSuccessMsg = translationService.getLocalizedString('Settings saved successfully'),
                settingErrorMsg = translationService.getLocalizedString('We were unable to update this user.'),
                deferred = $q.defer();

            personalSettings.timezoneNotificationStatus = (event === 'N') ? 'no' : (event === 'D') ? 'never' : 'yes';

            if(event === 'Y'){ //update the suggested timezone only if 'yes'
                personalSettings.timezone = CoreUserService.getTimezoneByBrowserTime();
            } else if (event === 'N'){ //show timezone flash message again after 7 days.
                personalSettings.nextTimezoneNotificationCheck = moment().add({days:7}).toDate().toISOString();
            }

            this.updateUser( userId , personalSettings )
                .then(function(response) {
                    if (response.data && typeof response.data === 'object') {
                        CoreUserService.setCurrent(response.data);
                        if(event === 'Y'){ //show success msg when the user clicks 'yes'
                            DialogService.flashSuccess(settingSuccessMsg);
                        }
                        deferred.resolve();
                    } else {
                        DialogService.flashError(settingErrorMsg);
                        deferred.reject();
                    }
                })
                .catch(function(response){
                    deferred.reject(response.data);
                });

            return deferred.promise;
        },
        getId: function getId () {
            return CoreCommon.isUsable(current) && CoreCommon.isUsable(current._id) ? current._id : null;
        },
        canSendOutboundMessages: function canSendOutboundMessages () {
            return true;
        },
        isLoggedIn: function isLoggedIn () {
            return this.getId() !== null;
        },
        getLanguage: function getLanguage () {
            if (CoreCommon.isUsable(current) && CoreCommon.isUsable(current.language)) {
                return typeof current.language === 'string' ? current.language : (current.language.code2 || null);
            } else {
                return null;
            }
        },
        setLanguage: function setLanguage (language) {
            if(language === 'us') {
                language = 'en';
            }
            current.language = language;
            if (language != $injector.get('translationService').getLanguage()) {
                $injector.get('translationService').setLanguage(language);
            }
        },
        getCountry: function getCountry () {
            return CoreCommon.isUsable(current) && CoreCommon.isUsable(current.country) ? current.country : null;
        },
        getEmail: function getEmail () {
            return CoreCommon.isUsable(current) && CoreCommon.isUsable(current.email) ? current.email : null;
        },
        getTimezone: function getTimezone () {
            return CoreCommon.isUsable(current) && CoreCommon.isUsable(current.timezone) ? current.timezone : 'Europe/London';
        },
        getTimezoneName: function getTimezoneName() {
            return CoreCommon.isUsable(current) && CoreCommon.isUsable(current.timezone) ? TimezoneService.getTimezoneName(current.timezone) : null;
        },
        getTimezoneNameByBrowserTime: function getTimezoneNameByBrowserTime() {
            return CoreCommon.isUsable(current) && CoreCommon.isUsable(current.timezone) ? TimezoneService.getTimezoneNameByBrowserTime(moment()) : null;
        },
        getTimezoneByBrowserTime: function getTimezoneByBrowserTime() {
            return CoreCommon.isUsable(current) && CoreCommon.isUsable(current.timezone) ? TimezoneService.getTimezoneByBrowserTime(moment()) : null;
        },
        /**
         * Adjust the given date to the user's timezone using moment.tz. Any format will do. (String, date object, moment)
         * If there is a timezone in the date, it will be honored, then we will convert to the user's timezone.
         * If there is not a timezone in the date, we will assume the date/time is in the user's timezone.
         * If you want UTC, just use moment.utc()!
         * @param date The date to convert to user timezone.
         * @returns A moment object with the adjusted date.
         */
        adjustDate: function adjustDateToTimezone(date) {
            return moment.tz(date, CoreUserService.getTimezone());
        },
        /**
         * Adjust the given date to the user's timezone using moment.tz. and then sets time to end of the current day. Any format will do. (String, date object, moment)
         * If there is a timezone in the date, it will be honored, then we will convert to the user's timezone.
         * If there is not a timezone in the date, we will assume the date/time is in the user's timezone.
         * If you want UTC, just use moment.utc()!
         * @param date The date to convert to user timezone.
         * @returns A moment object with the adjusted date.
         */
        adjustDateToEndOfDay: function adjustDateToEndOfDay(date) {
            var rightNow = moment.tz(date, CoreUserService.getTimezone()),
                endOfDayToday = rightNow.clone().utc().endOf('day');
            return endOfDayToday;
        },
        /**
         * Get the current date in the current timezone.
         * @returns A moment object with the date.
         */
        getCurrentDate: function getCurrentDate() {
            return moment.tz(CoreUserService.getTimezone());
        },
        /**
         * Returns the number of hours between two dates
         * @param start and end dates to calculate the number of hours between them
         * @returns Hours between two dates.
         */
        getTotalHoursBetweenDates: function getTotalHoursBetweenDates(now, later) {
            return Math.ceil(moment.duration(later.diff(now)).asHours());
        },
        getPasswordStrength: function getPasswordStrength (password) {
            // This code was taken from jquery.pwStrength. It seems silly to require the entire thing when we only use
            // this one function. Get it here:
            // https://github.com/matoilic/jquery.pwstrength/blob/master/jquery.pwstrength.js
            var score = 0, length = password.length, upperCase, lowerCase, digits, nonAlpha;

            if (length < 6) {
                return 0; // Min length.                          `
            }

            if(length < 5) {
                score += 0;
            }
            else if(length < 8) {
                score += 5;
            }
            else if(length < 16) {
                score += 10;
            }
            else {
                score += 15;
            }

            lowerCase = password.match(/[a-z]/g);
            if(lowerCase) {
                score += 1;
            }

            upperCase = password.match(/[A-Z]/g);
            if(upperCase) {
                score += 5;
            }

            if(upperCase && lowerCase) {
                score += 2;
            }

            digits = password.match(/\d/g);
            if(digits && digits.length > 1) {
                score += 5;
            }

            nonAlpha = password.match(/\W/g);
            if(nonAlpha) {
                score += (nonAlpha.length > 1) ? 15 : 10;
            }

            if(upperCase && lowerCase && digits && nonAlpha) {
                score += 15;
            }

            if(password.match(/\s/)) {
                score += 10;
            }

            if(score < 20) {
                return 1;
            }
            if(score < 35) {
                return 2;
            }
            if(score < 50) {
                return 3;
            }
            return 4;
        },
        getInfluencersSubTabs: function getInfluencersSubTabs () {
            var influencersSubTabsItems = [],
                isInfluencerDatabaseEntitled = CoreUserService.isIcmCountriesEntitlement,
                $route = $injector.get('$route'),
                lockerId = '',
                outreachPromise,
                newswirePromise,
                newSearchPromise,
                promises = [],
                deferred = $q.defer();

            if ($route.current.params.locker) {
                lockerId = $route.current.params.locker;
            }
            else {
                lockerId = PageStateService.getLockerId('contactListPage');
                if (lockerId === undefined || lockerId === '') {
                    if ($route.current.loadedTemplateUrl === 'icm-web/views/contact_search') {
                        lockerId = PageStateService.updateLockerId('influencerDatabase');
                    }
                    else if ($route.current.loadedTemplateUrl === 'icm-web/views/contact_list') {
                        lockerId = PageStateService.updateLockerId('contactListPage');
                    }
                }
            }

            influencersSubTabsItems.push({
                title:'My Influencers',
                link:'/influencers/contact?locker=' + lockerId,
                customIsActive: function() {
                    return ($location.url().indexOf('/influencers/contact?') === 0);
                }
            });

            if(isInfluencerDatabaseEntitled) {
                influencersSubTabsItems.push({title:'Keyword Search', link:'/influencers/contact/keywordSearch'});

                influencersSubTabsItems.push({
                    title: 'Influencer Database',
                    link: '/influencers/contact/search?locker=' + lockerId,
                    customIsActive : function customIsActive() {
                        return ($location.path().indexOf('/influencers/contact/search') > -1);
                    }
                });
            } else {
                influencersSubTabsItems.push({title: 'Influencer Database', link: '/influencers/contact/influencerdatabase'});
            }

            // add custom active checking so that things like '/outreach' and '/outreach/123' both show the Outreach tab as active
            function addOutreachSubTab() {
                influencersSubTabsItems.push({
                    title: 'Outreach',
                    link: '/influencers/contact/outreach',
                    customIsActive: function customIsActive() {
                        return ($location.path().indexOf(this.link) === 0);
                    }
                });
            }

            if(CoreUserService.isInfluencerAppEntitled === '') {
                EntitlementService.registerEntitlement('toggle', 'influencerApp', 'Influencers');
                outreachPromise = EntitlementService.getAccountEntitlement('influencerApp', null, 'status')
                    .then(function getAccountEntitlementThen(entitlement) {
                        CoreUserService.isInfluencerAppEntitled = (entitlement && entitlement.entitled)? true:false;
                        return CoreUserService.isInfluencerAppEntitled;
                    })
                    .catch(function(error){
                        return CoreUserService.isInfluencerAppEntitled = false;
                    });
                 promises.push(outreachPromise);
            } else if(CoreUserService.isInfluencerAppEntitled) {
                addOutreachSubTab();
            }

            function addNewswireSubtab() {
                influencersSubTabsItems.push({
                    title: 'influencers-subtabs__newswire',
                    link: '/newswire/landing',
                    customIsActive: function customIsActive() {
                        return ($location.path().indexOf('/newswire') === 0);
                    }
                });
            }

            if(CoreUserService.isNewswireEntitled === '') {
                newswirePromise = EntitlementService.getCompanyEntitlement('newswire').then(function(entitlement) {
                    CoreUserService.isNewswireEntitled = (entitlement && Object.keys(entitlement).length)? true:false;
                    return CoreUserService.isNewswireEntitled;
                }).catch(function(error){
                    return CoreUserService.isNewswireEntitled = false;
                });
                promises.push(newswirePromise);
            } else if(CoreUserService.isNewswireEntitled) {
                addNewswireSubtab();
            }

            function addNewSearchSubtab() {
                influencersSubTabsItems.push({
                    title: 'influencers-subtabs__search',
                    link: '/influencers/search',
                    customIsActive: function customIsActive() {
                        return ($location.path().indexOf('/influencers/search') === 0);
                    }
                });
            }

            if(CoreUserService.isNewSearchEntitled === '') {
                newSearchPromise = EntitlementService.getCompanyEntitlement('newIcmSearch').then(function(entitlement) {
                    CoreUserService.isNewSearchEntitled = (entitlement && entitlement.newIcmSearch && entitlement.newIcmSearch.value)? true:false;
                    return CoreUserService.isNewSearchEntitled;
                }).catch(function(error){
                    CoreUserService.isNewSearchEntitled = false;
                    return CoreUserService.isNewSearchEntitled;
                });
                promises.push(newSearchPromise);
            } else if(CoreUserService.isNewSearchEntitled) {
                addNewSearchSubtab();
            }


            if(promises.length>0) {
                $q.all(promises).then(function (promiseResults) {
                    if(promiseResults[0]) {
                        addOutreachSubTab();
                    }
                    if(promiseResults[1]) {
                        addNewswireSubtab();
                    }
                    if(promiseResults[2]) {
                        addNewSearchSubtab();
                    }
                    deferred.resolve(influencersSubTabsItems);
                }).catch(function(error){
                    deferred.reject(influencersSubTabsItems);
                });
            } else {
                deferred.resolve(influencersSubTabsItems);
            }
            return deferred.promise;
        },
        getSettingsSections: function getSettingsSections (){
            var settingsItems = [],
                manageUsersItem = {title:'Manage Users', link:'/settings/users'};

            settingsItems.push({title:'Personal Settings', link:'/settings/personal'});
            settingsItems.push({title:'Report Settings', link:'/settings/report'});
            settingsItems.push({title: 'RSS Feeds', link: '/settings/rss'});

            if (CoreUserService.hasAccess(manageUsersItem)) {
                settingsItems.push(manageUsersItem);
            }

            settingsItems.push({title:'Account Information', link:'/settings/account'});
            settingsItems.splice(3, 0, {title:'Add Content', link:'/settings/content'});

            if (CoreUserService.hasAccess(manageUsersItem)) {
                $q.all([
                    EntitlementService.getAccountEntitlement('influencerApp', null, "status"),
                    EntitlementService.getCompanyEntitlement('dyn-newsletter-entitlement')
                ])
                    .then(function getAccountEntitlementThen(entitlements) {
                        if ((entitlements[0] && entitlements[0].entitled)
                            ||
                            (entitlements[1] && entitlements[1]['dyn-newsletter-entitlement']
                            && entitlements[1]['dyn-newsletter-entitlement'].value === true)) {

                            settingsItems.push({title: 'Email Settings', link: '/settings/email'});
                        }
                    });
            }
            return settingsItems;
        },
        /*
            getSettingsTabs is a replacement for getSettingsSections.  getSettingsTabs is used by the new responsive nav chrome controller.
            getSettingsSections is only used by the "old" NON responsive nav controller.  When we eventually delete the old controller
            we should also delete getSettingsSections
        */
        getSettingsTabs: function getSettingsTabs() {
            var settingsTabsPromise = $q.defer(),
                settingsItems = [
                    {title:'Personal Settings', link:'/settings/personal'},
                    {title:'Report Settings', link:'/settings/report'},
                    {title: 'RSS Feeds', link: '/settings/rss'},
                    {title:'Add Content', link:'/settings/content'},
                    {title:'Account Information', link:'/settings/account'}
                ],
                manageUsersItem = {title:'Manage Users', link:'/settings/users'};

            if (CoreUserService.hasAccess(manageUsersItem)) {
                settingsItems.splice(4, 0, manageUsersItem);
                $q.all([
                    EntitlementService.getAccountEntitlement('influencerApp', null, "status"),
                    EntitlementService.getCompanyEntitlement('dyn-newsletter-entitlement')
                ])
                    .then(function getAccountEntitlementThen(entitlements) {
                        if ((entitlements[0] && entitlements[0].entitled)
                            ||
                            (entitlements[1] && entitlements[1]['dyn-newsletter-entitlement']
                            && entitlements[1]['dyn-newsletter-entitlement'].value === true)) {

                            settingsItems.push({title: 'Email Settings', link: '/settings/email'});
                        }
                    })
                    .finally(function resolvePromise(){
                        settingsTabsPromise.resolve(settingsItems);
                    });
            } else {
                settingsTabsPromise.resolve(settingsItems);
            }

            return settingsTabsPromise.promise;
        },
        isInternalUser: function isInternalUser () {
            if (typeof current === 'undefined') {
                return false;
            }

            return current.isInternal || false;
        },
        getName: function getName() {
            return CoreCommon.isUsable(current) ? current.name : '';
        },
        logout: function logout (redirectTo) {
            // Login Feature Toggle
            // NOTE: redirectTo not supported by feature toggle
            if($window.loginOrigin) {
                $window.location.href = $window.loginOrigin;
            } else {
                $cookies.remove('gydaToken', {path: '/'});
                $cookies.remove('gydaRemember', {path: '/'});

                if(!redirectTo) {
                    redirectTo = LOGOUT_URL;
                }

                // Force a page refresh by using $window.location.href.
                $window.location.href = redirectTo;
            }
        },

        logoutAccessRevoked: function logoutAccessRevoked () {
            // Login Feature Toggle
            if($window.loginOrigin) {
                // Wait for translations to be available in translationService - otherwise this could run too early and not be translated.
                translationService.waitForTranslations().then(function afterWaitForTranslations() {
                    CoreErrorNotificationService.notifyCurrentUser('userHasNoAccessToCompany').then(function(){
                        $window.location.href = $window.loginOrigin;
                    });
                });
            } else {
                $cookies.remove('gydaToken', {path: '/'});
                $cookies.remove('gydaRemember', {path: '/'});

                // Wait for translations to be available in translationService - otherwise this could run too early and not be translated.
                translationService.waitForTranslations().then(function afterWaitForTranslations() {
                    CoreErrorNotificationService.notifyCurrentUser('userHasNoAccessToCompany').then(function(){
                        $window.location.href = LOGOUT_URL;
                    });
                });
            }
        },

        /**
         * update user and company settings for Dont Show twitter toast
         * @returns {deferred.promise|{then}}
         */
        dontShowTwitterThrottledToast: function dontShowTwitterThrottledToast(){
            var userId = CoreUserService.getId(),
                CoreCompanyService = $injector.get('CoreCompanyService'),
                id = CoreCompanyService.getId(),
                currentUserDetail = CoreUserService.getCurrent(),
                deferred = $q.defer(),
                personalSettings = currentUserDetail.notifications ? currentUserDetail : {
                    notifications : {}
                };
            personalSettings.notifications[id] = {
                twitterThrottle : {
                    toastMessage : true
                }
            };
            CoreUserService.updateUser( userId , personalSettings )
                .then(function(response) {
                    if (response.data && typeof response.data === 'object') {
                        CoreUserService.setCurrent(response.data);
                        deferred.resolve();
                    } else {
                        deferred.reject();
                    }
                })
                .catch(function(response) {
                    deferred.reject(response.data);
                });

            return deferred.promise;

        },

        USERS_ENTITLEMENT: usersEntitlement,
        isIcmCountriesEntitlement : '',
        isNewswireEntitled: '',
        isNewSearchEntitled: '',
        isInfluencerAppEntitled: ''
    };

    /**
     * takes in a user object and takes the requested properties to include to create a subset that can be used for requesting data .
     * @param fullUser full user object or original object to pull data from
     * @param propertiesToInclude array of first level scope properties to add to the returned object. If the properties are not found it skips and continues
     * @returns object that has a subset of passed in object.
     */
    var createRequestUserData = function createRequestUserData (fullUser, propertiesToInclude) {
        var requestUserData = {};

        for (var x = 0; x < propertiesToInclude.length; x++) {
            if ('undefined' !== typeof fullUser[propertiesToInclude[x]]){
                requestUserData[propertiesToInclude[x]] = fullUser[propertiesToInclude[x]];
            }
        }

        return requestUserData;
    };

    /**
     * Factory to return the correct access handler for the provided target.
     * @param target The object for which user access is to be tested.
     * @returns {Function} Function to be called to determine whether the current user has access.
     */
    var getAccessHandler = function getAccessHandler (target) {
        var handler;

        if (target) {
            for (var i = 0; i < accessHandlers.length; i++) {
                handler = accessHandlers[i](target);

                if (handler) {
                    return handler;
                }
            }
        }

        return nullAccessHandler();
    };

    /**
     * Determines access to the provided angular route for the current user.
     * @param route The angular route to which a user might have restricted access.
     * @returns {Function} If param is a valid route, a function which returns true if the user has access; otherwise null.
     */
    var routeAccessHandler = function routeAccessHandler (route) {
        if (route.templateUrl && route.controller) {
            return function () {
                return !route.requireAdminRole || CoreUserService.getRoleId() === CoreUserService.getAvailableRoles().ADMINISTRATOR.value;
            };
        }

        return null;
    };

    /**
     * Determines access to the provided navItem for the current user by verifying
     * against the first applicable route among all available.
     * @param route The navItem to which a user might have restricted access.
     * @returns {Function} If param is a valid navItem, a function which returns true if the user has access; otherwise null.
     */
    var navItemAccessHandler = function navItemAccessHandler (navItem) {
        var $route = $injector.get('$route');

        if (navItem.link) {
            return function () {
                var route;

                if ('undefined' === typeof navItemAccessCache[navItem.link]) {
                    navItemAccessCache[navItem.link] = true;

                    for(var name in $route.routes) {
                        route = $route.routes[name];

                        if (route.regexp.test(navItem.link)) {
                            navItemAccessCache[navItem.link] = CoreUserService.hasAccess(route);
                            break;
                        }
                    }
                }

                return navItemAccessCache[navItem.link];
            };
        }

        return null;
    };

    // Cache to avoid route look-up for paths on subsequent requests
    var navItemAccessCache = { };

    // Clears the navItemAccessCache if the user is changed within the current session
    $rootScope.$on('userChanged', function () {
        navItemAccessCache = { };
    });

    /**
     * Access handler for unknown objects.
     * @returns {Function} A function which always returns true.
     */
    var nullAccessHandler = function nullAccessHandler () {
        return function () {
            return true;
        };
    };
    /**
     * Compare the user's timezone with what their browser is set to, and pop up a message if they don't match.
     */
    var checkUserTimezone = function checkUserTimezone() {

        // Find the user's current timezone offset via moment.
        var browserNow = moment(),
            userNow = moment.utc().tz(CoreUserService.getTimezone()),
            flashMessage = DialogService.getFlashMessage(timezoneFlashId),
            user = CoreUserService.getCurrent(),
            showTimezoneNotification = false;

        // Check to see if the user's timezone matches what is set in settings, and make sure we aren't already showing them an alert about it.
        if (browserNow.hour() != userNow.hour() || browserNow.minute() != userNow.minute()) {

            if (flashMessage !== null) {
                DialogService.removeFlash(timezoneFlashId);
            }

            // Wait for translations to be available in translationService - otherwise this could run too early and not be translated.
            translationService.waitForTranslations().then(function afterWaitForTranslations() {

                var message = $translate.instant('time-zone-smarter-alert__header-text') + ' ' + CoreUserService.getTimezoneNameByBrowserTime() +
                    '? &nbsp;&nbsp;&nbsp;<strong><a href="#" ng-click="updateTimezone(\'Y\')">' + $translate.instant('time-zone-smarter-alert__action-label__yes') +
                    '</a>&nbsp;&nbsp;&nbsp;<a href="#" ng-click="updateTimezone(\'N\')">'+ $translate.instant('time-zone-smarter-alert__action-label__no') +
                    '</a>&nbsp;&nbsp;&nbsp;<a href="#" ng-click="updateTimezone(\'D\')">'+ $translate.instant('time-zone-smarter-alert__action-label__dont-ask-again') +
                    '</a>&nbsp;&nbsp;&nbsp;<a href="/settings/personal">' + $translate.instant('Settings') +'</a></strong>';

                    if(typeof user.nextTimezoneNotificationCheck !== 'undefined' && user.timezoneNotificationStatus.toLowerCase() === 'no'){
                       showTimezoneNotification = moment(moment().toISOString()).isAfter( user.nextTimezoneNotificationCheck, 'day');
                    }

                    if(typeof user.timezoneNotificationStatus === 'undefined' || user.timezoneNotificationStatus.toLowerCase() === 'yes' || showTimezoneNotification){
                        if(CoreUserService.getTimezoneByBrowserTime() !== user.timezone){
                            // Save this id to remove the flash message later, and to let us know we are already showing a message.
                            timezoneFlashId = DialogService.flashWarning(message, 0, {class: 'timezoneMismatch', uniqueId: 'timezoneMismatch',  hideOnPageChange: false});
                        }
                    }
            });
        } else if (flashMessage !== null) {
            // If we get in here, we're showing a flash message, and the user has set their timezone to match their browser settings. Let's hide that message!
            DialogService.removeFlash(timezoneFlashId);
        }
    };

    var accessHandlers = [
        routeAccessHandler,
        navItemAccessHandler
    ];

    return CoreUserService;
}])
.service('user', ['$injector', function($injector) {
    return $injector.get('CoreUserService');
}]);